"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var core_1 = require('@angular/core');
var ionic_angular_1 = require('ionic-angular');
/**
 * Directive for adding a custom icon to an ion-tab element. Use the input properties 'customIconSet' and
 * 'customIconName' to set the icon's set and name.
 *
 * Example usage:
 * @usage
 * ```html
 * <ion-tab customIconSet="mySet" customIconName="myIcon" ...></ion-tab>
 * ```
 *
 * @author Gerrit Erpenstein
 */
var TabCustomIcon = (function () {
    function TabCustomIcon(_elementRef, _tabs) {
        this._elementRef = _elementRef;
        this._tabs = _tabs;
        /**
         * Icon set name
         */
        this.iconSet = '';
        /**
         * Icon name
         */
        this.iconName = '';
    }
    /**
     * (Called after Angular projects external content into its view.)
     */
    TabCustomIcon.prototype.ngAfterContentInit = function () {
        var _this = this;
        setTimeout(function () {
            _this._addIcon();
            _this._update();
        });
    };
    /**
     * Add icon element to it's corresponding tab.
     * @private
     */
    TabCustomIcon.prototype._addIcon = function () {
        var element = this._elementRef.nativeElement, tabsElement = this._tabs.getElementRef().nativeElement, index = -1, childNodes = tabsElement.childNodes, childNode, tabBarNode, tabNode;
        // Find tab bar node and index of tab item
        for (var i = 0, l = childNodes.length; i < l; i++) {
            childNode = childNodes[i];
            if (childNode.nodeType === 1) {
                if (childNode.nodeName === 'ION-TABBAR') {
                    // tab bar found!
                    tabBarNode = childNode;
                }
                else if (childNode.nodeName === 'ION-TAB') {
                    index++;
                    if (element === childNode) {
                        // target tab found!
                        break;
                    }
                }
            }
        }
        if (index === -1) {
            throw 'TabCustomIcon: Error finding tab index.';
        }
        // Find tab node in tab bar
        if (tabBarNode) {
            childNodes = tabBarNode.childNodes;
            var tabBarIndex = -1;
            for (var i = 0, l = childNodes.length; i < l; i++) {
                childNode = childNodes[i];
                if (childNode.nodeType === 1 && childNode.nodeName === 'A') {
                    tabBarIndex++;
                    if (index === tabBarIndex) {
                        // found target tab node
                        tabNode = childNode;
                        break;
                    }
                }
            }
        }
        else {
            throw 'TabCustomIcon: Error finding tab bar node "ion-tabbar"';
        }
        // add icon to tab
        if (tabNode) {
            // remove class 'has-title-only' from tab, add class 'has-icon'
            var tabCssClass = tabNode.className;
            tabCssClass = tabCssClass.replace(/(?:^|\s)has-title-only(?!\S)/, '');
            if (!/has-title/.test(tabCssClass))
                tabCssClass += ' icon-only';
            tabCssClass += ' has-icon';
            tabNode.className = tabCssClass;
            // create and add custom-icon element to tab
            this._iconElement = document.createElement('custom-icon');
            tabNode.insertBefore(this._iconElement, tabNode.firstChild);
        }
        else {
            throw 'TabCustomIcon: Target tab not found.';
        }
    };
    /**
     * (Called on input parameter value changes.)
     */
    TabCustomIcon.prototype.ngOnChanges = function (changes) {
        if (this._iconElement)
            this._update();
    };
    /**
     * Update/set the icon's css class.
     * @private
     */
    TabCustomIcon.prototype._update = function () {
        var cssClass = this.iconSet + '-' + this.iconName;
        this._iconElement.className = cssClass;
        this._iconElement.className += ' tab-button-icon';
    };
    /**
     * (Called just before Angular destroys the directive/component.)
     */
    TabCustomIcon.prototype.ngOnDestroy = function () {
        // remove icon element from DOM
        if (this._iconElement) {
            var parentNode = this._iconElement.parentNode;
            if (parentNode) {
                parentNode.removeChild(this._iconElement);
            }
        }
    };
    __decorate([
        core_1.Input('customIconSet'), 
        __metadata('design:type', String)
    ], TabCustomIcon.prototype, "iconSet", void 0);
    __decorate([
        core_1.Input('customIconName'), 
        __metadata('design:type', String)
    ], TabCustomIcon.prototype, "iconName", void 0);
    TabCustomIcon = __decorate([
        core_1.Directive({
            selector: 'ion-tab[customIconSet],ion-tab[customIconName],'
        }),
        __param(1, core_1.Host()), 
        __metadata('design:paramtypes', [core_1.ElementRef, ionic_angular_1.Tabs])
    ], TabCustomIcon);
    return TabCustomIcon;
}());
exports.TabCustomIcon = TabCustomIcon;
//# sourceMappingURL=tab-custom-icon.directive.js.map